<nb-card accent="danger">
  <nb-card-header class="header-card"><h2>Atenção</h2></nb-card-header>
  <nb-card-body>
    <div class="container">
      <p>{{ firstMessage }}</p>
      <p><strong>{{ emphasisMessage }}</strong></p>
      <p>{{ secondMessage }}</p>
    </div>
  </nb-card-body>
  <nb-card-footer class="d-flex flex-row-reverse justify-content-between">
    <div><button type="button" class="btn btn-success" (click)="confirmSelection(true)">
      Sim
    </button>
    </div>
    <div><button type="button" class="btn btn-danger" (click)="confirmSelection(false)">
      Não
    </button></div>
  </nb-card-footer>
</nb-card>
